app.directive('checkImage', function() {
	return {
		link: function(scope, element) {
			element.bind('error', function() {
				element.attr('src', '/images/blank.png'); // set default image
			});
		}
	};
});